export default __webpack_public_path__ + "app/images/theme-images/light/emoji-picker-disabled/icon-20-emoji@2x.webp";